import React from 'react'

import Carousel from '../../components/CarouselComponent/CarouselComponent'
import englishReviews from './english.json'
import {
  authorImage,
  authorInfo,
  authorName,
  container,
  reviewCard,
  reviewContent,
  reviewText,
  sectionStyling,
  star,
  starsContainer,
} from './GoogleReviews.module.css'

const filteredEnglishReviews = englishReviews.slice(0, 15)

const GoogleReviews = ({ url }) => {
  const title =
    url === '/mothersday/'
      ? ' Why Moms Love Essential Aesthetics'
      : 'Google Reviews'

  return (
    <div className={sectionStyling}>
      <div className={container}>
        <h2>{title}</h2>
        <Carousel
          breakpoints={{
            760: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
          }}
          slidesPerView={1}
          spaceBetween={30}
          withoutNav
        >
          {filteredEnglishReviews.map((review) => (
            <div key={review.author_title} className={reviewCard}>
              <div className={starsContainer}>
                {[...Array(5)].map((_, i) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <span key={i} className={star}>
                    ★
                  </span>
                ))}
              </div>
              <div className={authorInfo}>
                <img
                  alt={`${review.author_title} profile`}
                  className={authorImage}
                  loading="lazy"
                  src={review.author_image}
                />
                <h3 className={authorName}>{review.author_title}</h3>
              </div>
              <div className={reviewContent}>
                <p className={reviewText}>{review.review_text}</p>
              </div>
            </div>
          ))}
        </Carousel>
      </div>
    </div>
  )
}

export default GoogleReviews
